const QUEUE_KEY = "performance-tracker-pending";
const MAX_ITEMS = 50;

function readQueue() {
  if (typeof sessionStorage === "undefined") return [];
  try {
    const raw = sessionStorage.getItem(QUEUE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeQueue(items) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(QUEUE_KEY, JSON.stringify(items.slice(-MAX_ITEMS)));
}

export function enqueuePending(item) {
  const next = readQueue();
  next.push({
    ...item,
    queuedAt: Date.now(),
  });
  writeQueue(next);
}

export function peekPending() {
  return readQueue();
}

export function takePending() {
  const items = readQueue();
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(QUEUE_KEY);
  }
  return items;
}

export function isRetryableTrackerError(err) {
  const status = err?.status;
  if (status == null) return true;
  return status >= 500;
}
